export interface DayData {
  date: string
  dayName: string
  caloriesIn: number
  caloriesOut: number
  protein: number
  carbs: number
  fats: number
}

export const weekData: DayData[] = [
  {
    date: '2024-01-15',
    dayName: 'Mon',
    caloriesIn: 2100,
    caloriesOut: 2400,
    protein: 150,
    carbs: 220,
    fats: 65,
  },
  {
    date: '2024-01-16',
    dayName: 'Tue',
    caloriesIn: 1950,
    caloriesOut: 2200,
    protein: 140,
    carbs: 200,
    fats: 60,
  },
  {
    date: '2024-01-17',
    dayName: 'Wed',
    caloriesIn: 2250,
    caloriesOut: 2500,
    protein: 165,
    carbs: 240,
    fats: 70,
  },
  {
    date: '2024-01-18',
    dayName: 'Thu',
    caloriesIn: 2000,
    caloriesOut: 2300,
    protein: 145,
    carbs: 210,
    fats: 62,
  },
  {
    date: '2024-01-19',
    dayName: 'Fri',
    caloriesIn: 2300,
    caloriesOut: 2600,
    protein: 170,
    carbs: 250,
    fats: 75,
  },
  {
    date: '2024-01-20',
    dayName: 'Sat',
    caloriesIn: 2400,
    caloriesOut: 2100,
    protein: 160,
    carbs: 260,
    fats: 80,
  },
  {
    date: '2024-01-21',
    dayName: 'Sun',
    caloriesIn: 2150,
    caloriesOut: 2350,
    protein: 155,
    carbs: 225,
    fats: 68,
  },
]

export const todayData = weekData[weekData.length - 1]
